"use client";
import {
  FrameworkProvider
} from "../chunk-FVY6EZ3N.js";
import "../chunk-MLKGABMK.js";

// src/framework/next.tsx
import { useParams, usePathname, useRouter } from "next/navigation";
import Link from "next/link";
import Image from "next/image";
import { jsx } from "react/jsx-runtime";
function NextProvider({ children }) {
  return /* @__PURE__ */ jsx(
    FrameworkProvider,
    {
      usePathname,
      useRouter,
      useParams,
      Link,
      Image,
      children
    }
  );
}
export {
  NextProvider
};
